import React, { Children } from 'react';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const menuCategories = [{
  name: 'Signature Plates',
  items: [{
    name: 'Beef Tibs',
    description: 'Tender beef cubes sautéed with onions, rosemary, and jalapeños.',
    price: '$22'
  }, {
    name: 'Chicken Sambusa',
    description: 'Crispy pastry shells filled with spiced minced chicken and herbs.',
    price: '$14'
  }, {
    name: 'Lentil Sambusa',
    description: 'Traditional spiced lentil filling in a golden pastry crust.',
    price: '$12'
  }, {
    name: 'Red Lounge Wings',
    description: 'Signature spiced wings served with a house dipping sauce.',
    price: '$16'
  }]
}, {
  name: 'Shared Experiences',
  items: [{
    name: 'Vegetarian Platter',
    description: 'A collection of traditional Ethiopian vegetable stews and salads.',
    price: '$24'
  }, {
    name: 'Kitfo',
    description: 'Finely minced lean beef seasoned with mitmita and niter kibbeh.',
    price: '$26'
  }, {
    name: 'Doro Wot',
    description: 'Traditional spicy chicken stew simmered with berbere and hard-boiled eggs.',
    price: '$25'
  }]
}];
export function Eat() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <main className="bg-obsidian min-h-screen" data-id="element-208">
      <div className="pt-24 md:pt-28 pb-16 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12 md:mb-16" data-id="element-210">
          <h1 className="text-5xl md:text-8xl font-serif text-champagne mb-6" data-id="element-211">
            EAT
          </h1>
          <p className="text-white/60 font-sans text-xl md:text-2xl max-w-2xl mx-auto" data-id="element-212">
            A boutique collection of Ethiopian-inspired flavors and contemporary
            bar bites.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16" data-id="element-213">
          {menuCategories.map((category, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} data-id="element-214">
              <h2 className="text-sm uppercase tracking-[0.4em] text-champagne mb-8 md:mb-12 border-b border-champagne/20 pb-4" data-id="element-215">
                {category.name}
              </h2>
              <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
            once: true
          }} className="space-y-8 md:space-y-12" data-id="element-216">
                {category.items.map((item, i) => <motion.div key={i} variants={itemVariants} className="group cursor-pointer" data-id="element-217">
                    <div className="flex justify-between items-baseline mb-2" data-id="element-218">
                      <h3 className="text-2xl font-serif text-white group-hover:text-champagne transition-colors duration-300" data-id="element-219">
                        {item.name}
                      </h3>
                      <span className="text-champagne/60 font-sans text-sm tracking-widest group-hover:text-champagne transition-colors duration-300" data-id="element-220">
                        {item.price}
                      </span>
                    </div>
                    <p className="text-white/40 font-sans text-lg leading-relaxed group-hover:text-white/70 transition-colors duration-300" data-id="element-221">
                      {item.description}
                    </p>
                  </motion.div>)}
              </motion.div>
            </motion.div>)}
        </div>
      </div>
      <Footer data-id="element-222" />
    </main>;
}